import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import PrecinctLocations from "./sections/PrecinctLocations";
import ReachOurTeam from "./sections/ReachOurTeam";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <PrecinctLocations />
      <ReachOurTeam />
      <Footer />
    </div>;
}